module.exports = __webpack_public_path__ + "img/img_product_cultivate_village@3x.6cf4999c.png";